export const getSubCategories = (categoryList, categoryObject) => {
  let newCat = { ...categoryObject };
  const subcats = categoryList.filter(
    (cat) => cat.parent === categoryObject.identifier
  );

  if (!subcats?.length) {
    return newCat;
  }

  newCat.subcategories = subcats.map((subcat) => ({
    ...getSubCategories(categoryList, subcat),
  }));

  return newCat;
};

export const getCategoryPath = (
  identifier,
  language,
  categoryTree,
  category
) => {
  if (!category) {
    for (let i = 0; i < categoryTree.length; i++) {
      const categoryArr = getCategoryPath(
        identifier,
        language,
        categoryTree,
        categoryTree[i]
      );

      if (
        categoryArr?.length &&
        categoryArr[0].identifier === categoryTree[i].identifier
      ) {
        return categoryArr;
      } else if (categoryArr?.length) {
        return [
          {
            identifier: categoryTree[i].identifier,
            link: "/category/" + categoryTree[i].identifier,
            name: categoryTree[i].name[language],
            ...(categoryTree[i].subcategories
              ? { subcategories: categoryTree[i].subcategories }
              : {}),
          },
          ...categoryArr,
        ];
      }
    }

    return;
  }

  if (category.identifier === identifier) {
    return [
      {
        identifier: category.identifier,
        link: "/category/" + category.identifier,
        name: category.name[language],
        ...(category.subcategories
          ? { subcategories: category.subcategories }
          : {}),
      },
    ];
  }

  if (!category.subcategories?.length) {
    return;
  }

  return getCategoryPath(identifier, language, category.subcategories);
};
